import React from "react";

export default function Tabs({ tabs, active, onChange, className = "" }) {
  return (
    <div className={`flex gap-1 overflow-x-auto no-scrollbar border-b border-slate-200 ${className}`}>
      {tabs.map((tab) => (
        <button
          key={tab.value}
          onClick={() => onChange(tab.value)}
          className={`relative flex shrink-0 items-center gap-1.5 whitespace-nowrap px-4 py-2.5 text-sm font-medium transition-colors ${
            active === tab.value
              ? "text-primary-600"
              : "text-slate-500 hover:text-slate-800"
          }`}
        >
          {tab.icon}
          {tab.label}
          {typeof tab.count === "number" && (
            <span
              className={`ml-0.5 rounded-full px-1.5 py-0.5 text-[11px] ${
                active === tab.value ? "bg-primary-50 text-primary-600" : "bg-slate-100 text-slate-500"
              }`}
            >
              {tab.count}
            </span>
          )}
          {active === tab.value && (
            <span className="absolute inset-x-3 -bottom-px h-0.5 rounded-full bg-primary-600" />
          )}
        </button>
      ))}
    </div>
  );
}
